var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m0 0h32v32h-32z","fill":"none","key":0}),React.createElement("path",{"d":"m9.667 20.333v-8.666h-8.667a1 1 0 0 1 0-2h8.667v-8.667a1 1 0 1 1 2 0v8.666h8.667a1 1 0 0 1 0 2h-8.667v8.666a1 1 0 1 1 -2 0z","fill":"#21393d","transform":"matrix(.70710678 .70710678 -.70710678 .70710678 16 .915)","key":1})]);
}

Close.defaultProps = {"height":"32","viewBox":"0 0 32 32","width":"32"};

module.exports = Close;

Close.default = Close;
